import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { invalidateSolarFinancingLockReaders } from "./solar-financing-lock-readers"
import type {
  SolarCreditHumanAttemptBody,
  SolarCreditHumanHandoffDto,
} from "../dto/solar-proposal-financing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Replace the current application with a new attempt from the current Quote.
 */
export default function useReplaceSolarCreditHuman(): UseMutationResult<
  SolarCreditHumanHandoffDto,
  unknown,
  {
    proposalId: string
    applicationId: string
    body: SolarCreditHumanAttemptBody
  }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId, body }) =>
      solarProposalService.replaceCreditHuman(proposalId, applicationId, body),
    // Fire and forget: the handoff tab waits on this mutation, so it must not
    // also wait on unrelated refetches.
    onSettled: (_data, _error, { proposalId }) => {
      invalidateSolarFinancingLockReaders(queryClient, proposalId)
    },
  })
}
